export const POPUP_CHANNELS_TYPE = {
  use: 'use',
  sell: 'sell'
};

export const CHANNELS_METHOD_NAME = {
  topUpBalance: 'topUpBalance'
}
